import { useApolloClient } from "@apollo/client";
import { Badge, Box, Button, Divider, Grid, IconButton, Stack } from "@mui/material";
import React from "react";
import FilterIMG from "../../../../../assets/filter";
import { AlertDialog, FilterGenerator, LoadingSection, SearchFilter, TableWithPagination, UseDebounce } from "../../../../../components";
import { config } from "../../../../../config";
import { AlertContext, BackdropContext } from "../../../../../contexts";
import { UPDATE_PROPERTY_AMENITIES } from "../../../../../graphql/mutations";
import { GET_PROPERTY_AMENITIES_TABLE_LIST } from "../../../../../graphql/queries";
import { NetworkCall } from "../../../../../networkcall/index";
import { AlertProps, AmenitiesHeadingUnit, AmenitiesPath, LocalStorageKeys, NetWorkCallMethods } from "../../../../../utils";
import { AddAmenitiesPopup } from "../../../addAmenitiesPopup";
import { PropertyAmenitiesStyles } from "./style";
import moment from "moment";
import { addHours, subSeconds } from 'date-fns'
import { useHistory } from "react-router-dom";
import { Routes } from "../../../../../router/routes";
const initialState = () => {
    return {
        id: null,
        amenity: "",
        chargeable: "Yes",
        amount: "",
        period: "",
        status: "Active",
        description: "",
        edit: false,
        view: false,
        error: {
            amenity: "",
            chargeable: "",
            amount: "",
            period: "",
            status: "",

        },
    }
}

export const PropertyAmenities = (props) => {
    const defaultFilterState = { status: [true] };
    const { t = () => false } = (props)
    const classes = PropertyAmenitiesStyles();
    const alert = React.useContext(AlertContext);
    const backdrop = React.useContext(BackdropContext);
    const [propertyAmenities, setPropertyAmenities] = React.useState({ ...initialState() })
    const [propertyAmenitieslist, setPropertyAmenitiesList] = React.useState({
        data: [],
        count: 0,
    })
    const [openDialog, setOpenDialog] = React.useState(false)
    const [drawer, setDrawer] = React.useState(false);
    const [searchText, setSearchText] = React.useState("");
    const [page, setPage] = React.useState(1);
    const [loading, setLoading] = React.useState(true)
    const [limit, setLimit] = React.useState(10);
    const debounce = UseDebounce();
    const [filterData, setFilterData] = React.useState(defaultFilterState);
    const companyId = props?.companyId
    const currencyId = props?.currency?.id
    const propertyId = props?.propertyId
    const client = useApolloClient()
    const clientId = localStorage.getItem(LocalStorageKeys.clinetID)
    const history = useHistory()

    //pagination
    const handlePagination = (value) => {
        setPage(value);
        let offset = (value - 1) * limit;
        PropertyAmenitiesTableData(offset, limit, searchText)
    }
    //page change limit
    const handleChangeLimit = (value) => {
        setLimit(value);
        setPage(1);
        PropertyAmenitiesTableData(0, value, searchText)
    }
    // search
    const handleSearch = (e) => {
        setSearchText(e)
        debounce(() => searchTableFunction(e), 800)
    }
    //search function
    const searchTableFunction = (e) => {
        if (page > 1) {
            setPage(1);
        }
        PropertyAmenitiesTableData(0, limit, e)
    }
    //table listingfunction
    const PropertyAmenitiesTableData = async (offset = 0, limit = 10, search = "") => {
        let is_active = filterData?.status ?? [];
        let chargeable = filterData?.chargeable ?? [];
        const payload = {
            query: GET_PROPERTY_AMENITIES_TABLE_LIST(clientId, offset, limit, search, propertyId, is_active, chargeable).loc.source.body,

        };
        NetworkCall(
            `${config.graphql_url}`,
            NetWorkCallMethods.post,
            payload,
            null,
            true,
            false).then((response) => {
                const list = response?.data?.data?.property_facilities?.map((val) => {
                    let _d;
                    try {
                        _d = {
                            amenityName: val?.amenities_type_master?.amenities_name ?? "-",
                            chargeable: val?.is_chargeable ? "Yes" : "No",
                            amount: val?.rate ? `${val?.currencyByID?.symbol ?? ""} ${val?.rate ?? "-"}` : " - ",
                            period: val?.period ?? "-",
                            status: val?.is_active ? "Active" : "Inactive",
                            description: val?.description ?? "-",
                            icon: "more",
                            id: val?.id,
                            amenityId: val?.amenities_type_master?.id ?? "-",
                            booking: val?.amenities_type_master?.is_booking ? "Yes" : "No",
                            periodd: { value: val?.period, label: val?.period },
                            IsDelete: val?.is_delete,
                            amountt: val?.rate ?? "-"
                        };
                    } catch (err) {

                    }
                    return _d;

                })
                setPropertyAmenitiesList({
                    data: list,
                    count: response?.data?.data?.count?.[0]?.count,

                })
                setLoading(false)
                backdrop.setBackDrop({
                    ...backdrop,
                    open: false,
                    message: "",
                });
            }).catch((error) => {
                backdrop.setBackDrop({
                    ...backdrop,
                    open: false,
                    message: "",
                });
                alert.setSnack({
                    ...alert,
                    open: true,
                    severity: AlertProps.severity.error,
                    msg: t("Some Thing Went Wrong"),
                });
            });
    }

    // is active changing function
    const changeactive = async (data, value) => {
        client.mutate({
            mutation: UPDATE_PROPERTY_AMENITIES,
            variables: {
                ID: data,
                updatePayload: {
                    is_active: value === "Inactive" ? true : false
                }
            }
        }).then(rs => {
            alert.setSnack({
                ...alert,
                open: true,
                severity: AlertProps.severity.success,
                msg: t("Status Updated"),
            });
            PropertyAmenitiesTableData()
        }).catch(er => {
            console.log(er)
        })
    }
    //delete function
    const deleteTableData = async (data) => {
        client.mutate({
            mutation: UPDATE_PROPERTY_AMENITIES,
            variables: {
                ID: data,
                updatePayload: {
                    is_delete: true
                }
            }
        }).then(rs => {
            alert.setSnack({
                ...alert,
                open: true,
                severity: AlertProps.severity.success,
                msg: t("Deleted"),
            });
            PropertyAmenitiesTableData()
        }).catch(er => {
            console.log(er)
        })
    }

    React.useEffect(() => {
        if (props?.permission?.read) {
            if (propertyId) {
                PropertyAmenitiesTableData()
                // getEnum()
            }
        }
        //eslint-disable-next-line
    }, [propertyId, filterData, props?.permission]);

    //table icon click function
    const handleIcon = (type, data, status) => {
        if (type === "view") {
            // setOpenDialog(true)
            navigateAmenityMapping(type, data)
            setPropertyAmenities({
                ...propertyAmenities,
                amenityName: data?.amenityName,
                chargeable: data?.chargeable,
                amount: data?.amountt,
                period: data?.periodd,
                description: data?.description,
                booking: data?.booking === "yes" ? { label: "Required", value: "Required" } : { label: "Not Required", value: "Not Required" },
                amenity: { label: data?.amenityName, value: data?.amenityId },
                edit: false,
                view: true,
                id: data?.id,
                status: data?.status,
                type: "property"
            })
        }
        if (type === "edit") {
            // setOpenDialog(true)
            navigateAmenityMapping(type, data)
            setPropertyAmenities({
                ...propertyAmenities,
                amenityName: data?.amenityName,
                chargeable: data?.chargeable,
                amount: data?.amountt,
                period: data?.periodd,
                description: data?.description,
                booking: data?.booking === "yes" ? { label: "Required", value: "Required" } : { label: "Not Required", value: "Not Required" },
                amenity: { label: data?.amenityName, value: data?.amenityId },
                edit: true,
                id: data?.id,
                status: data?.status,
                type: "property"
            })
        }
        else if (type === "active") {
            changeactive(data.id, status)
        }
        else if (type === "delete") {
            deleteTableData(data.id, data.IsDelete)
        }

    }
    //apply filter
    const onApplyFilter = (value) => {
        setFilterData(value)
    }

    //onclose modal
    const OncloseModal = () => {
        setOpenDialog(false)
        setPropertyAmenities({ ...initialState() })
    }
    //Pop up netwoerk call

    const getPropertyAmenities = (e) => {
        // eslint-disable-next-line
        let const_arr = e?.slot_time.map((arr) => {
            if (arr.length !== 0)
                return [
                    moment(arr[0]).format("HH:mm:ss"),
                    moment(subSeconds(addHours(new Date(arr[arr.length - 1]), 1), 1)).format("HH:mm:ss")
                ]

        })

        const result = const_arr.filter(element => {
            return element !== undefined
        })
        const variables = {
            "id": e?.id ?? undefined,
            "is_active": e?.status,
            "property_id": propertyId ?? undefined,
            "amenities_type": e?.amenity_reference?.value ?? undefined,
            "is_chargeable": e?.amenity_reference?.is_booking ? e?.chargeable : false ?? undefined,
            "total_slots": e?.amenity_reference?.is_booking ? e?.slot_time.length === 0 ? 1 : e?.slot_time.length : undefined ?? undefined,
            "applicable_days": e?.days?.length > 0 ? e?.days : [],
            "slot_partition": e?.slot?.length > 0 ? e?.slot : undefined,
            "selected_slots": result ?? undefined,
            "currency_id": currencyId ?? undefined,
            "rate": e?.amenity_reference?.is_booking ? e?.chargeable_value : 0 ?? undefined,
            "period": e?.amenity_reference?.is_booking ? e?.slot_type : undefined,
            "amenity_category_id": e?.amenity_category?.id ?? undefined,
            "participants_count": e?.participant !== "" ? e?.participant : undefined
        }

        NetworkCall(
            `${config.api_url}/property_facilities/upsert`,
            NetWorkCallMethods.post,
            variables,
            null,
            true,
            false
        )
            .then((response) => {
                if (response?.data?.type === "success") {
                    OncloseModal()
                    PropertyAmenitiesTableData(0, 10, "")
                }
            })
            .catch((error) => {

            });
    }

    const navigateAmenityMapping = (type, data) => {
        history.push({
            pathname: Routes.amenityMappingNew,
            state: {
                companyId: companyId,
                currencyId: currencyId,
                propertyId: propertyId,
                view: type === 'view' ? true : false,
                edit: type === 'edit' ? true : false,
                create: type === 'create' ? true : false,
                id: data?.id ?? undefined,
                type: "property"
            }
        })
    }

    return (
        <>
            {
                loading ? <LoadingSection bottom={"45vh"} message="Loading Amenities Listing..." /> :
                    <div>
                        <Box p={2} className={classes.root} marginTop={1}>
                            <Grid container >
                                <Grid item xs={4}>
                                    <SearchFilter value={searchText} placeholder={t("Search amenities")} handleChange={(value) => handleSearch(value)} />
                                </Grid>
                                <Grid item xs={8}>
                                    <Box
                                        display={"flex"}
                                        sx={{ justifyContent: "end" }}>
                                        <Stack
                                            direction="row"
                                            divider={<Divider orientation="vertical" flexItem />}
                                            spacing={2}>
                                            {filterData.status?.length > 0 || filterData.property_type?.length > 0 ? (
                                                <IconButton onClick={() => setDrawer(true)} className={classes.img}>
                                                    <Badge variant="dot" color="primary">
                                                        <FilterIMG color="#091b29" />
                                                    </Badge>
                                                </IconButton>

                                            ) : (
                                                <IconButton onClick={() => setDrawer(true)} className={classes.img}>
                                                    <FilterIMG color="#091b29" />
                                                </IconButton>)}
                                            {props?.permission?.create &&
                                                <Button
                                                    variant="contained"
                                                    // sx={{ borderRadius: theme.palette.borderRadius }}
                                                    className={classes.btn}
                                                    onClick={() => navigateAmenityMapping('create')}
                                                >
                                                    {t("Add Amenities")}
                                                </Button>}

                                        </Stack>
                                    </Box>
                                </Grid>
                            </Grid>
                            <TableWithPagination
                                noDataSvg
                                heading={AmenitiesHeadingUnit(t)}
                                rows={propertyAmenitieslist?.data}
                                path={AmenitiesPath}
                                showpagination={true}
                                count="2"
                                showpdfbtn={false}
                                showexcelbtn={false}
                                showSearch={false}
                                handleIcon={handleIcon}
                                tableType="no-side"
                                onClick={() => console.log("")}
                                dataType={[
                                    { type: ["text"], name: "amenityName" },
                                    { type: ["description"], name: "description" },
                                    { type: ["text"], name: "chargeable" },
                                    { type: ["text"], name: "amount" },
                                    { type: ["text"], name: "period" },
                                    { type: ["text"], name: "booking" },
                                    { type: ["status"], name: "status" },
                                    { type: ["more"], icon: "icon" },

                                ]}
                                handlePagination={handlePagination}
                                handleChangeLimit={handleChangeLimit}
                                totalRowsCount={propertyAmenitieslist?.count}
                                page={page}
                                limit={limit}
                                height={`calc(100vh - 395px)`}
                                view={props?.permission?.read}
                                edit={props?.permission?.update}
                                delete={props?.permission?.delete} />
                        </Box>
                    </div>
            }
            {/* filter drawer */}
            {
                drawer &&
                <FilterGenerator
                    open={drawer}
                    onClose={() => setDrawer(false)}
                    components={[

                        {
                            component: "toggleButton",
                            value: filterData?.status,
                            options: [
                                { label: 'Active', value: true },
                                { label: 'Inactive', value: false },
                            ],
                            isMulti: true,
                            state_name: "status",
                            label: t("Status"),
                        },
                        {
                            component: "toggleButton",
                            value: filterData?.chargeable,
                            options: [
                                { label: 'Yes', value: true },
                                { label: 'No', value: false },
                            ],
                            isMulti: true,
                            state_name: "chargeable",
                            label: t("Chargeable"),
                        },
                    ]}
                    onApply={(value) => onApplyFilter(value)}
                    defaultState={defaultFilterState}
                />
            }
            {/* add and edit  and view */}
            <AlertDialog
                md
                header={propertyAmenities?.view ? t("View Amenities") : propertyAmenities?.edit ? t("Edit Amenities") : t("Add Amenities")}
                onClose={OncloseModal}
                open={openDialog}
                component={
                    <>
                        <div>
                            <AddAmenitiesPopup t={t} click={getPropertyAmenities} currency={props?.currency}
                                data={propertyAmenities} companyId={companyId} closeModel={OncloseModal}
                                type={"property"} />
                            {/* {
                                dontShow &&
                                addAndEdit()
                            } */}
                        </div>
                    </>
                }
            />
        </>
    );
};
